var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "comments-section"
  }, [_c('h3', {
    staticClass: "fs-16 fw-bold clr-title mb-4"
  }, [_vm._v("Comments")]), _vm.loading ? _c('div', {
    staticClass: "text-center p-4"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "comment_listwrapper"
  }, [_c('div', {
    class: ['comment_list', {
      scrollable: _vm.comments.length > 4
    }]
  }, [_vm._l(_vm.comments, function (comment) {
    var _comment$commented_by;

    return _c('div', {
      key: comment.id
    }, [_c('div', {
      staticClass: "comment_item d-flex align-items-start gap-3"
    }, [_vm._m(1, true), _c('div', {
      staticClass: "comment_content d-flex flex-column gap-1",
      staticStyle: {
        "width": "100%",
        "max-width": "100%"
      }
    }, [_c('div', {
      staticClass: "comment_header d-flex align-items-center gap-3 flex-wrap"
    }, [_c('span', {
      staticClass: "comment_author fs-16 clr-black fw-semibold"
    }, [_vm._v(_vm._s(((_comment$commented_by = comment.commented_by) === null || _comment$commented_by === void 0 ? void 0 : _comment$commented_by.name) || 'Unknown User'))]), _c('span', {
      staticClass: "comment_date clr-bold-grey font-13"
    }, [_vm._v(_vm._s(_vm.formatDate(comment.created_at) || 'Unknown date'))])]), _c('div', {
      staticClass: "comment_text fs-16 mb-0",
      staticStyle: {
        "width": "100%"
      },
      domProps: {
        "innerHTML": _vm._s(comment.comment || 'No content')
      }
    }), comment !== null && comment !== void 0 && comment.document && comment.document.length > 0 ? [_c('div', {
      staticClass: "comment_document mt-3"
    }, [_c('p', {
      staticClass: "fs-16 clr-bold-grey mb-3"
    }, [_vm._v("Documents:")]), _c('div', {
      staticClass: "row"
    }, _vm._l(comment.document, function (document) {
      return _c('div', {
        key: document.id,
        staticClass: "col-md-6 col-lg-4 mb-4"
      }, [_c('div', {
        staticClass: "ticket_documentInfo d-flex align-items-center gap-3 h-100 p-3 border rounded"
      }, [_vm._m(2, true), _c('div', {
        staticClass: "document_content d-flex flex-column gap-1 flex-grow-1"
      }, [_c('a', {
        staticClass: "document_link d-flex align-items-center gap-1 justify-content-between text-decoration-none",
        attrs: {
          "href": document.full_file_url,
          "target": "_blank"
        }
      }, [_c('span', {
        staticClass: "clr-primary fw-semibold text-truncate"
      }, [_vm._v(" " + _vm._s(document.original_file_name) + " ")]), _vm._m(3, true)]), _c('div', {
        staticClass: "document_info d-flex align-items-center gap-2 flex-wrap font-14"
      }, [_c('span', {
        staticClass: "dots"
      }), _c('span', {
        staticClass: "clr-title fw-medium"
      }, [_vm._v(" Uploaded: "), _c('span', {
        staticClass: "clr-bold-grey fw-normal"
      }, [_vm._v(_vm._s(_vm.formatDate(document.updated_at || document.created_at)))])])])])])]);
    }), 0)])] : _vm._e()], 2)]), _c('hr')]);
  }), !_vm.comments || _vm.comments.length === 0 ? _c('div', {
    staticClass: "text-center p-4 text-muted"
  }, [_vm._v(" No comments available ")]) : _vm._e()], 2)]), _c('div', {
    staticClass: "mt-4 mb-4"
  }, [_c('input-quill-editor', {
    ref: "commentEditor",
    attrs: {
      "vmodel": _vm.newComment,
      "placeholder": "Add your message here ...",
      "error": _vm.commentError,
      "formGroupClass": "editorInputWrapper"
    },
    on: {
      "update:vmodel": function updateVmodel($event) {
        _vm.newComment = $event;
      },
      "ready": _vm.onEditorReady
    }
  })], 1), _c('div', {
    staticClass: "button-wrapper d-flex justify-content-end align-items-center gap-3 flex-wrap"
  }, [_vm._m(4), _c('span', {
    staticClass: "file-name"
  }, [_vm._v(" " + _vm._s(_vm.form.comment_document.length ? _vm.form.comment_document.map(function (f) {
    return f.name;
  }).join(', ') : 'No file chosen') + " ")]), _c('input', {
    attrs: {
      "type": "file",
      "id": "fileInput",
      "hidden": "",
      "multiple": ""
    },
    on: {
      "change": _vm.handleFileChange
    }
  }), _c('b-button', {
    staticClass: "univ-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.submitting || !_vm.addComment
    },
    on: {
      "click": _vm.submitComment
    }
  }, [_vm.submitting ? _c('span', [_c('span', {
    staticClass: "spinner-border spinner-border-sm me-2",
    attrs: {
      "role": "status"
    }
  }), _vm._v(" Submitting... ")]) : _c('span', [_vm._v("Comment")])])], 1), _vm.commentError ? _c('div', {
    staticClass: "text-danger small mt-2"
  }, [_vm._v(" " + _vm._s(_vm.commentError) + " ")]) : _vm._e(), _vm.error ? _c('div', {
    staticClass: "alert alert-danger mt-3",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(" " + _vm._s(_vm.error) + " ")]) : _vm._e()]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "spinner-border",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading comments...")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "avatar_user flex-shrink-0"
  }, [_c('img', {
    staticClass: "rounded-circle",
    attrs: {
      "src": require("../../../assets/images/user.svg"),
      "width": "46",
      "height": "46"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "icon-wrapper flex-shrink-0"
  }, [_c('img', {
    staticClass: "w-100 h-100",
    attrs: {
      "src": require("./../../../assets/images/quotes.svg"),
      "alt": "document icon"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "link_icon d-flex align-items-center justify-content-center clr-primary font-14"
  }, [_c('i', {
    staticClass: "fa-solid fa-arrow-up-right-from-square"
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "btn attach-btn d-flex align-items-center",
    attrs: {
      "for": "fileInput"
    }
  }, [_c('i', {
    staticClass: "fas fa-paperclip mr-2"
  }), _vm._v(" Attach File ")]);
}]

export { render, staticRenderFns }